import posthog from 'posthog-js'

posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
   persistence: 'localStorage',  
   persistence_name: 'posthog-session',       
  capture_pageview: true,     
  autocapture: true,         
})

export default posthog